module.exports = __webpack_public_path__ + "img/GI.b0db4ef4.svg";